import { useShallow } from "zustand/react/shallow";
import { useThemeStore } from "../../logic/stores/themeStore.js";

export function StatusBadge({ label, colors, accent }) {
  const active = label === "active" || label === "online";
  const color = active ? (colors?.success ?? accent) : colors?.mid;
  return (
    <span
      style={{
        fontSize: 11,
        fontWeight: 600,
        padding: "2px 8px",
        borderRadius: 999,
        background: `${color}18`,
        color,
        textTransform: "capitalize",
      }}
    >
      {label}
    </span>
  );
}

export function useThemeSlice() {
  return useThemeStore(
    useShallow((s) => ({
      c: s.c,
      accentHex: s.accentHex,
      dark: s.dark,
      accent: s.accent,
      chrome: s.chrome,
      typography: s.typography,
      setDark: s.setDark,
      setAccent: s.setAccent,
    })),
  );
}
